/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import loadable from '@loadable/component';

import CircularLoader from './shared/loader/circular';
import { preloadComponent } from '../utils';

const LazyForm = loadable(() => import('./form/components/form'), {
  fallback: <CircularLoader />,
});

const FormBase = () => {
  useEffect(() => preloadComponent(LazyForm), []);

  return (
    <Router basename="/form">
      <Route path="/:id" render={(props) => <LazyForm {...props} />} />
    </Router>
  );
};

export default FormBase;
